// extracted by mini-css-extract-plugin
module.exports = {"reviewsTooltipContainer":"reviews-tooltip_reviewsTooltipContainer__mcIoq","reviewsTooltip":"reviews-tooltip_reviewsTooltip__xaYUD"};